module.exports = __webpack_public_path__ + "static/media/virus (1).33f2695a.png";